import React from "react";
import Page, { PageProps } from "../Page";
import DataGrid from "../../components/app/grid/DataGrid";
import { IRegisteredApplicantsPresenter } from "../../../presenter/applicants/RegisteredApplicantsPresenter";
import { TGridAction } from "../../components/app/grid/GridActionsDropdown";
import Loader from "../../components/Loader";
import { Form } from "antd";
import RegisterApplicantForm, {
  RegisterApplicantFormProps
} from "../../components/applicants/details/RegisterApplicantForm";

export interface Props extends PageProps {}
export interface State extends IRegisteredApplicantsPresenter {}

export default class RegisteredApplicantsPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      registeredApplicants,
      showApplicantDetails,
      canShowApplicantDetails,
      canRegisterApplicant,
      registerApplicant,
      unregisteredParties
    } = this.state;

    const CreateForm = Form.create<RegisterApplicantFormProps>({})(
      RegisterApplicantForm
    );

    CreateForm.defaultProps = {
      translate,
      parties: unregisteredParties
    };

    const actions: TGridAction[] = [
      {
        label: translate("registered_applicant_page.details"),
        onClick: (record) => (e) => showApplicantDetails(record.id),
        type: "primary"
      }
    ];
    const columns = [
      {
        title: translate("registered_applicant_page.personalID"),
        dataIndex: "personalID",
        key: "personalID"
      },
      {
        title: translate("registered_applicant_page.firstName"),
        dataIndex: "firstName",
        key: "firstName"
      },
      {
        title: translate("registered_applicant_page.fatherName"),
        dataIndex: "fatherName",
        key: "fatherName"
      },
      {
        title: translate("registered_applicant_page.lastName"),
        dataIndex: "lastName",
        key: "lastName"
      },
      {
        title: translate("registered_applicant_page.motherSurname"),
        dataIndex: "motherSurname",
        key: "motherSurname"
      },
      {
        title: translate("registered_applicant_page.placeOfBirth"),
        dataIndex: "placeOfBirth",
        key: "placeOfBirth"
      },
      {
        title: translate("registered_applicant_page.name"),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate("registered_applicant_page.description"),
        dataIndex: "description",
        key: "description"
      }
    ];

    const dataGrid = (
      <DataGrid
        actions={canShowApplicantDetails() ? actions : []}
        title={translate("grids.registered-applicants")}
        translate={translate}
        columns={columns}
        dataSource={registeredApplicants}
        allowCreate={canRegisterApplicant()}
        createForm={CreateForm}
        onCreate={async (values) => await registerApplicant(values.partyId)}
        createModalTitle={translate(
          "registered_applicant_page.register_modal_title"
        )}
        addButtonText={translate(
          "registered_applicant_page.register_applicant"
        )}
      />
    );

    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          translate={translate}
          loading={this.state.loaders.registeredApplicantsLoader}
        />
      </Page>
    );
  }
}
